import { useState, type FormEvent } from "react";
import { useRejectCityOrder } from "../../../api/cityOrders";
import CityOrderDrawer from "./CityOrderDrawer";

const CHECKABLE = ["received", "revised"];

/** On a City PO recorded but not yet checked: check it against the BOQ
 * (again, from its stored PDF), or reject it with a reason. */
export default function CheckActions({
  orderId,
  number,
  status,
  hasPdf,
}: {
  orderId: number;
  number: string;
  status: string;
  /** The order has its PDF on file: the check reads it, so without one there is nothing to check. */
  hasPdf: boolean;
}) {
  const [checking, setChecking] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [reason, setReason] = useState("");
  const reject = useRejectCityOrder(orderId);
  if (!CHECKABLE.includes(status)) {
    return null;
  }
  function onReject(event: FormEvent) {
    event.preventDefault();
    reject.mutate(reason.trim(), { onSuccess: () => setRejecting(false) });
  }
  return (
    <div className="move-buttons">
      {hasPdf ? (
        <button type="button" className="btn btn-primary" onClick={() => setChecking(true)}>
          Check the City's PO against the BOQ
        </button>
      ) : (
        <p className="cm-doc-note">Attach the City's PDF first</p>
      )}
      {!rejecting ? (
        <button type="button" className="btn btn-danger" onClick={() => setRejecting(true)}>
          Reject this PO
        </button>
      ) : (
        <form onSubmit={onReject} aria-label={`Reject PO ${number}`}>
          <label className="move-note">
            Why is PO {number} rejected?
            <textarea value={reason} rows={2} maxLength={500} required onChange={(event) => setReason(event.target.value)} />
          </label>
          <button type="submit" className="btn btn-danger" disabled={reject.isPending || reason.trim() === ""}>
            Reject
          </button>
          <button type="button" className="btn" onClick={() => setRejecting(false)}>
            Keep it
          </button>
          {reject.isError ? <p className="notice bad">{reject.error.message}</p> : null}
        </form>
      )}
      {checking && hasPdf ? <CityOrderDrawer boqId={null} orderId={orderId} onClose={() => setChecking(false)} onSaved={() => setChecking(false)} /> : null}
    </div>
  );
}
